import React, { ReactNode } from "react";
import styled from "styled-components";

interface SplitViewLayoutProps {
	children?: ReactNode;
}

const SplitViewLayout: React.FC<SplitViewLayoutProps> = ({ children }) => {
	return <SplitViewLayoutStyles>{children}</SplitViewLayoutStyles>;
};

export default SplitViewLayout;

const SplitViewLayoutStyles = styled.div`
	background-color: white;
	height: 100%;
	width: 23.4375rem;
	position: absolute;
	right: 0;
	z-index: 100;

	border: 1px solid ${(props) => props.theme.colors.INPUT_BORDER};
	box-sizing: border-box;
	box-shadow: inset 1px 0px 0px rgba(0, 0, 0, 0.1);
	border-top-left-radius: 1.5625rem;
	border-bottom-left-radius: 1.5625rem;
	padding: 1.5625rem;
	overflow: hidden;
`;
